import { PROCESS } from "../../data/content";
import { Chapter, Reveal, Btn } from "../shared";

export default function Process() {
  return (
    <section className="relative overflow-hidden bg-emerald-deep py-24 md:py-32" data-testid="process-section">
      <div className="pointer-events-none absolute right-0 top-0 select-none font-serif text-[26rem] leading-none text-ivory/[0.03]">05</div>
      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="03" title="Our Process" dark />
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl md:text-6xl leading-[1.05] text-ivory">
            Five steps to your <span className="italic text-gold-light">big day</span>
          </h2>
        </Reveal>

        <div className="mt-16">
          {PROCESS.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.05}>
              <div className="grid grid-cols-[auto_1fr] items-start gap-6 border-t border-gold/15 py-8 md:grid-cols-[120px_1fr_2fr] md:gap-12 md:py-10" data-testid={`process-step-${p.num}`}>
                <span className="font-serif text-4xl md:text-6xl italic text-gold/80 leading-none">{p.num}</span>
                <h3 className="font-serif text-2xl md:text-4xl text-ivory pt-1">{p.title}</h3>
                <p className="col-span-2 md:col-span-1 max-w-2xl text-sm md:text-base leading-relaxed text-ivory/60 pt-2 md:pt-3">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14 text-center">
          <Btn to="/contact" testid="process-cta">Plan My Wedding</Btn>
        </Reveal>
      </div>
    </section>
  );
}
